import { SITE_NAME } from "./Site";

export const WEB_DOMAIN = SITE_NAME;
export const NO_IMAGE = `${SITE_NAME}assets/images/no-image.jpg`;
export const IMAGE_URL = `${SITE_NAME}images/v1/`;
export const NO_STORE_IMAGE = '';
export const NO_USER_IMAGE = '';
export const QR_CODE_IMAGE = '';